<template>
  <div class="w-full h-screen">
    <div class="flex shadow rounded-md h-screen">
      <div
        class="bg-wave dark:bg-gray-900 bg-white w-2/5 lg:block hidden"
      ></div>
      <div class="bg-white dark:bg-gray-900 w-full">
        <form>
          <div
            class="form-body lg:max-w-xl mx-auto lg:p-10 p-8 lg:mt-20 mt-5 space-y-8"
          >
            <div class="flex gap-2 justify-center">
              <div
                class="cursor-pointer"
                @click="$router.push('/')"
              >
                <img
                  src="../../../assets/logo/logobisi.png"
                  alt=""
                  class="w-10"
                />
              </div>
              <h2 class="dark:text-white font-semibold text-gray-800 text-4xl">
                Reset Password<span class="text-primary">.</span>
              </h2>
            </div>
            <div v-if="trueAll" class="flex justify-center">
              <div>
                <h4 class="dark:text-white font-semibold text-gray-800">Change Password Succesfull</h4>
                <button
                  v-on:click.prevent="$router.push('/login')"
                  class="text-white mt-5 bg-primary hover:bg-primary/80 p-3 w-full rounded-md"
                >
                  Return To Login
                </button>
              </div>
            </div>
            <div v-else class="flex justify-center">
              <div v-if="isLoading">
                <Vue3Lottie :animationData="loading" :width="200" />
              </div>
              <div v-else class="w-full">
                <div v-if="isNotValid">
                  <p class="text-center m-5 text-red-600 text-lg">{{ textError }}</p>
                </div>
                <div v-else>
                  <div class="relative z-0 w-full mb-3 group">
                    <input
                      type="password"
                      name="floating_email"
                      id="floating_email"
                      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary focus:outline-none focus:ring-0 focus:border-primary peer"
                      placeholder=" "
                      required
                      v-model="newPassword"
                    />
                    <label
                      for="floating_email"
                      class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary peer-focus:dark:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >New Password</label
                    >
                  </div>
                  <div class="relative z-0 w-full mb-6 group">
                    <input
                      type="password"
                      name="floating_email"
                      id="floating_email2"
                      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-primary focus:outline-none focus:ring-0 focus:border-primary peer"
                      placeholder=" "
                      required
                      v-model="newPasswordConfirm"
                    />
                    <label
                      for="floating_email"
                      class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-primary peer-focus:dark:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >Confirm New Password</label
                    >
                  </div>
                  <p class="text-red-600 text-sm">{{ textError2 }}</p>
                  <div v-if="isLoading2">
                      <Vue3Lottie :animationData="loading2" :width="50" />
                  </div>
                  <button
                    v-else
                    v-on:click.prevent="changePasswordHandler"
                    class="text-white mt-5 bg-primary hover:bg-primary/80 p-3 w-full rounded-md"
                  >
                    Submit New Password
                  </button>
                </div>
             </div>
            </div>
          </div>
        </form>
      </div>
      <div
        class="bg-wave dark:bg-gray-900 bg-white w-2/5 lg:block hidden"
      ></div>
    </div>
  </div>
</template>

<script>
  import { useCounterStore } from '@/store/counter';
  import { mapActions } from 'pinia';
  import { Vue3Lottie } from 'vue3-lottie';
  import loading from "@/assets/loading10.json"
  import loading2 from "@/assets/loading9.json"
  export default {
    name: "Forgot Password",
    components: {
      Vue3Lottie
    },
    data() {
      return {
        newPassword: '',
        newPasswordConfirm: '',
        loading,loading2, 
        isLoading: true,
        textError: '',
        isNotValid: true,
        isLoading2: false,
        textError2: '',
        trueAll: false
      };
    },
    methods: {
      ...mapActions(useCounterStore,['forgotPassword','checkToken','changePassword']),
      async changePasswordHandler(){
        this.textError2 = ''
        if(this.newPassword === this.newPasswordConfirm){
          this.isLoading2 = true
          const check = await this.changePassword(this.newPassword,this.$route.query.token)
          if(check != true){
            this.textError2 = check
          }else{
            this.trueAll = true
          }
          this.isLoading2 = false
        }else{
          this.textError2 = "Passwords are not the same"
        }
      },
      async checkTokenHandler() {
        try {
          this.token = this.$route.query.token;
          if (!this.token) {
            this.textError = 'Token is missing in the URL';
            throw {}
          }
          const response = await this.checkToken(this.token);
          if (response !== true) {
            this.textError = response;
            throw {}
          }
          this.isLoading = false
          this.isNotValid= false
        } catch (error) {
          this.isLoading = false
          this.isNotValid = true
        }
      }
    },
    created(){
      this.checkTokenHandler()
    }
  };
</script>
<style>
  /* custom pattern https://superdesigner.co/tools/css-backgrounds */
  .bg-wave {
    background: radial-gradient(
        circle at top left,
        transparent 25%,
        #4f46e5 25.5%,
        #4f46e5 36%,
        transparent 37%,
        transparent 100%
      ),
      radial-gradient(
        circle at bottom right,
        transparent 34%,
        #4f46e5 34.5%,
        #4f46e5 45.5%,
        transparent 46%,
        transparent 100%
      );
    background-size: 6em 6em;
    opacity: 1;
  }
</style>
